<template>
  <div>
    <div class="fix-wrapper">
      <breadcrumb
        :crumbs="[$t('menu.agentChecks') + '：' + $route.query.name]"
      ></breadcrumb>
      <div class="container">
        <div class="pd20">
          <div class="import">
            <ul class="orange">
              <li class="explain">
                {{ $t("importDeliveryCheckAgent.excelTitle") }}
              </li>
              <li class="explain">
                {{ $t("newImport.excelTemplate") }}:
                <a :href="excelTemplate" target="_blank">{{
                  $t("newImport.clickDownload")
                }}</a>
              </li>
              <li class="explain">
                {{ $t("newImport.beCareful") }}：1、{{
                  $t("newImport.beCarefulMustFill")
                }}
              </li>
            </ul>
          </div>
          <div class="center">
            <el-upload
              ref="upload"
              :action="url"
              :headers="fileHeaders"
              :show-file-list="false"
              :before-upload="beforeAvatarUpload"
              :on-success="importResult"
              accept=".xls, .xlsx"
              :data="params"
            >
              <el-button
                type="success"
                size="small"
                style="width: 100px"
                :loading="importLoading"
                >{{ $t("action.import") }}</el-button
              >
            </el-upload>
          </div>
        </div>

        <div class="form-footer">
          <back-button />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { page } from "@/utils/mixins.js";
import { coreEndpoint, fileserverEndpoint } from "@/settings";
import Util from "@/utils";
import BackButton from "@/components/BackButton";
import RawHtmlLimitNumber from "@/components/RawHtmlLimitNumber";

import Cookies from "@/utils/cookies.js";
import DeliverySettlement from "@/api/deliverySettlement.js";

export default {
  mixins: [page],
  components: { BackButton, RawHtmlLimitNumber },
  data() {
    var validateTitle = (rule, value, callback) => {
      const self = this;
      if (value == null) {
        callback(
          new Error(this.$t("rules.required", [this.$t("settlement.title")]))
        );
        return;
      }
      DeliverySettlement.findByTitle({ title: value }).then(function (res) {
        if (res.data.code === 200) {
          callback(
            new Error(self.$t("rules.exist", [self.$t("settlement.title")]))
          );
          return;
        } else {
          callback();
        }
      });
    };
    return {
      excelTemplate:
        fileserverEndpoint + "/public/excelTemplates/jy_deliverImportCost.xlsx",
      // 导入
      url: null,

      fileHeaders: {
        type: "web",
        token: Cookies.getToken(),
      },
      params: {
        title: null,
      },
      importLoading: false,
    };
  },

  computed: {},
  created() {
    const self = this;
    self.url =
      coreEndpoint +
      "/excels/import-courier-cost/agent/" +
      self.$route.params.id;
    self.params.title =
      self.$route.query.name + Util.serialNoSimple() + Util.randNNumber(3);
  },
  methods: {
    // 导入
    beforeAvatarUpload(file) {
      this.importLoading = true;
      return true;
    },
    importResult(res, file) {
      const self = this;
      this.importLoading = false;
      // console.log("====", res);
      self.$router.push({ name: "fnReportsDeliverChecksAgents" });
      // self.results = res.datas;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>